<template>
  <div class="header-wrapper" ref="headerWrapper" :class="{ scrolled: isScrolled }">
    <!-- 公告横幅 · 蜜光金底 -->
    <div class="notice" v-if="showBanner" @click="bannerClick">
      <span class="notice-tag"><i class="fas fa-bell"></i><span>新课</span></span>
      <span class="notice-text">{{ bannerText }}</span>
      <span class="notice-arrow">→</span>
      <button class="notice-close" @click.stop="closeBanner" aria-label="关闭">×</button>
    </div>

    <header class="header">
      <div class="header-content">
        <!-- Logo -->
        <router-link to="/" class="brand" aria-label="坤和静界">
          <img src="@/assets/images/logo/logo.png" alt="坤和静界" class="brand-logo"/>
        
        </router-link>

        <!-- PC 导航 -->
        <nav class="nav-pc" aria-label="主导航">
          <ul class="nav">
            <li v-for="(item, i) in navList" :key="item.path">
              <router-link :to="item.path" class="nav-link" :class="`nav-link--${i % 4}`" :exact="item.path === '/'">
                <span class="nl-dot"></span>
                <span>{{ item.name }}</span>
              </router-link>
            </li>
          </ul>
        </nav>

        <div class="header-right">
          <router-link to="/contact" class="btn btn-rose cta-desktop">
            <span>留言咨询</span>
            <span class="btn-arrow">→</span>
          </router-link>
          <button
            class="mob-toggle"
            :class="{ active: showMobileNav }"
            @click="toggleMobileNav"
            aria-label="菜单"
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>

    <!-- mob-drawer 必须放在 .header 外部
         否则 .header.scrolled 的 backdrop-filter 会让 .header 成为
         fixed 子元素的 containing block，造成滚动时 drawer 位置错位 -->
    <transition name="mnav">
      <div
        class="mob-drawer"
        v-show="showMobileNav"
        :style="{ top: headerOffset + 'px', maxHeight: 'calc(100vh - ' + headerOffset + 'px)' }"
      >
        <span class="mob-orb mob-orb-rose"></span>
        <span class="mob-orb mob-orb-sage"></span>
        <p class="mob-greet font-hand">你来这里 · 是被陪伴的</p>
        <ul class="mob-list">
          <li v-for="(item, i) in moblieNavList" :key="item.path" @click="showMobileNav = false">
            <router-link :to="item.path" :exact="item.path === '/'">
              <span class="ml-num font-display">0{{ i + 1 }}</span>
              <span class="ml-name">{{ item.name }}</span>
              <span class="ml-arrow">→</span>
            </router-link>
          </li>
        </ul>
        <div class="mob-foot">
          <router-link to="/contact" class="btn btn-rose mob-cta">
            <span>留言咨询</span>
            <span class="btn-arrow">→</span>
          </router-link>
          <a href="tel:19927640438" class="mob-phone">
            <span class="mp-label font-hand">或直接拨打</span>
            <span class="mp-num">199 2764 0438</span>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      showMobileNav: false,
      showBanner: true,
      isScrolled: false,
      headerOffset: 78,
      handleResize: null,
      handleScroll: null,
      bannerText: "《厌学休学破局》修复动力赋能专题课上线 · 点击了解",
      bannerLink: "https://yc.sll81.com/wuxiu/html/open-mini.html?path=%2FapplyPackage%2Fcourse_detail&query=id%3D4",
      navList: [
        { path: "/", name: "首页" },
        { path: "/services/youth", name: "春藤计划" },
        { path: "/services/entrepreneur", name: "躺平计划" },
        { path: "/services/training", name: "疗愈师认证" },
        { path: "/services/popularize", name: "心理科普" },
        { path: "/team", name: "疗愈师" },
        { path: "/about", name: "关于" }
      ],
      moblieNavList: [
        { path: "/", name: "首页" },
        { path: "/services/youth", name: "春藤计划 - 青少年休学" },
        { path: "/services/entrepreneur", name: "躺平计划 - 企业家心力提升" },
        { path: "/services/training", name: "疗愈师认证" },
        { path: "/services/popularize", name: "心理科普" },
        { path: "/team", name: "疗愈师" },
        { path: "/about", name: "关于" }
      ]
    };
  },
  watch: { $route() { this.showMobileNav = false; } },
  mounted() {
    this.handleResize = () => this.updateHeaderOffset();
    this.handleScroll = () => { this.isScrolled = window.scrollY > 24; };
    this.updateHeaderOffset();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
    document.documentElement.style.removeProperty("--header-offset");
  },
  methods: {
    toggleMobileNav() {
      /* 切换前先重算 offset，确保横幅 + header 的当前高度准确 */
      this.updateHeaderOffset();
      this.showMobileNav = !this.showMobileNav;
    },
    closeBanner() {
      this.showBanner = false;
      this.$nextTick(() => this.updateHeaderOffset());
    },
    bannerClick() { if (this.bannerLink) window.open(this.bannerLink, "_blank"); },
    updateHeaderOffset() {
      this.$nextTick(() => {
        const h = this.$refs.headerWrapper ? this.$refs.headerWrapper.offsetHeight : 0;
        this.headerOffset = h;
        document.documentElement.style.setProperty("--header-offset", `${h}px`);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.header-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  transition: filter 0.4s;
}
.header-wrapper.scrolled .header {
  background: rgba(250, 243, 232, 0.92);
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
}

/* 公告 · 蜜光金 */
.notice {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 9px 60px 9px 20px;
  background: var(--honey);
  color: var(--ink);
  cursor: pointer;
  position: relative;
  transition: background 0.35s;
  &:hover { background: var(--honey-d); color: var(--milk); }
}
.notice-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: var(--ink);
  color: var(--honey-pale);
  border-radius: 999px;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  i { font-size: 10px; color: var(--honey-pale); }
}
.notice:hover .notice-tag {
  background: var(--milk);
  color: var(--ink);
  i { color: var(--rose-d); }
}
.notice-text {
  font-family: var(--font-body);
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: 0.02em;
}
.notice-arrow {
  font-family: var(--font-display);
  font-size: 16px;
  color: var(--rose-d);
  transition: transform 0.35s;
}
.notice:hover .notice-arrow { color: var(--milk); transform: translateX(4px); }
.notice-close {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: rgba(58, 46, 37, 0.6);
  border-radius: 50%;
  transition: all 0.3s;
  &:hover { background: rgba(58, 46, 37, 0.15); color: var(--ink); }
}

/* Header */
.header {
  background: transparent;
  transition: background 0.4s, backdrop-filter 0.4s;
}
.header-content {
  max-width: 1380px;
  margin: 0 auto;
  padding: 0 var(--gutter);
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

/* Brand */
.brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  color: var(--ink);
  flex-shrink: 0;
}
.brand-logo {
  height: 46px;
  width: auto;
}
.brand-text { display: inline-flex; flex-direction: column; line-height: 1.05; }
.brand-cn {
  font-family: var(--font-cn);
  font-weight: 500;
  font-size: 17px;
  letter-spacing: 0.18em;
  color: var(--ink);
}
.brand-sub {
  font-size: 14px;
  color: var(--rose-d);
  margin-top: 2px;
}

/* PC 导航 · 每个 link 一个对应主色小圆点 */
.nav-pc { flex: 1; display: flex; justify-content: center; }
.nav { display: flex; gap: 4px; }
.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 500;
  color: var(--ink-2);
  border-radius: 999px;
  transition: color 0.25s, background 0.25s;
  .nl-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--ink-4);
    transition: background 0.25s, transform 0.3s;
  }
  &:hover { color: var(--ink); .nl-dot { transform: scale(1.6); } }
  &.router-link-exact-active {
    color: var(--ink);
    background: var(--paper-2);
  }
}
.nav-link--0 .nl-dot { background: var(--rose); }
.nav-link--0:hover .nl-dot { background: var(--rose-d); }
.nav-link--1 .nl-dot { background: var(--sage); }
.nav-link--1:hover .nl-dot { background: var(--sage-d); }
.nav-link--2 .nl-dot { background: var(--honey); }
.nav-link--2:hover .nl-dot { background: var(--honey-d); }
.nav-link--3 .nl-dot { background: var(--lavender); }
.nav-link--3:hover .nl-dot { background: var(--lavender-d); }

/* 右侧 CTA */
.header-right { display: flex; align-items: center; gap: 12px; }
.cta-desktop { padding: 11px 22px; font-size: 13.5px; }

/* Mobile toggle */
.mob-toggle {
  display: none;
  width: 44px;
  height: 44px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: var(--vellum);
  border-radius: 50%;
  box-shadow: var(--shadow-soft);
  transition: background 0.3s;
  span {
    display: block;
    width: 18px;
    height: 1.8px;
    background: var(--ink);
    border-radius: 2px;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
  &.active {
    background: var(--rose);
    span { background: var(--milk); }
    span:nth-child(1) { transform: translateY(4px) rotate(45deg); }
    span:nth-child(2) { transform: translateY(-4px) rotate(-45deg); }
  }
}

/* Mobile drawer */
.mob-drawer {
  position: fixed;
  top: var(--header-offset, 78px);
  left: 0;
  width: 100%;
  background: var(--paper);
  padding: 22px var(--gutter) 32px;
  max-height: calc(100vh - var(--header-offset, 78px));
  overflow-y: auto;
  z-index: 998;
  overflow-x: hidden;
}
.mob-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(50px);
  opacity: 0.5;
  pointer-events: none;
  z-index: 0;
}
.mob-orb-rose {
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, var(--rose) 0%, transparent 70%);
  top: -80px;
  right: -60px;
}
.mob-orb-sage {
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, var(--sage) 0%, transparent 70%);
  bottom: 0;
  left: -50px;
}
.mob-greet {
  position: relative;
  z-index: 1;
  font-size: 20px;
  color: var(--rose-d);
  margin-bottom: 18px;
  text-align: center;
}
.mob-list {
  position: relative;
  z-index: 1;
  li a {
    display: flex;
    align-items: baseline;
    gap: 14px;
    padding: 14px 4px;
    font-family: var(--font-cn);
    font-weight: 500;
    font-size: 17px;
    color: var(--ink);
    border-bottom: 1px dashed var(--line);
    transition: color 0.25s, padding-left 0.3s;
    .ml-num {
      font-style: italic;
      font-size: 14px;
      color: var(--ink-4);
      flex: 0 0 26px;
    }
    .ml-name { flex: 1; letter-spacing: 0.12em; }
    .ml-arrow {
      font-family: var(--font-display);
      color: var(--ink-4);
      transition: transform 0.3s, color 0.25s;
    }
    &:hover, &.router-link-exact-active {
      color: var(--rose-d);
      padding-left: 8px;
      .ml-arrow { color: var(--rose-d); transform: translateX(4px); }
    }
  }
}
.mob-foot {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 26px;
  padding-top: 22px;
  border-top: 1px dashed var(--line);
}
.mob-cta { width: 100%; justify-content: center; }
.mob-phone {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  .mp-label { font-size: 14px; color: var(--ink-4); }
  .mp-num {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 500;
    font-size: 22px;
    color: var(--sage-d);
    letter-spacing: 0.04em;
  }
}

.mnav-enter-active, .mnav-leave-active {
  transition: opacity 0.4s, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.mnav-enter, .mnav-leave-to { opacity: 0; transform: translateY(-10px); }

@media (max-width: 1100px) {
  .nav-link { padding: 8px 12px; font-size: 13px; }
  .brand-sub { display: none; }
}

@media (max-width: 768px) {
  .header-content { height: 64px; padding: 0 18px; gap: 14px; }
  .brand-logo { height: 36px; }
  .brand-cn { font-size: 15.5px; letter-spacing: 0.15em; }
  .nav-pc { display: none; }
  .cta-desktop { display: none; }
  .mob-toggle { display: flex; }
  .notice {
    padding: 7px 38px 7px 14px;
    gap: 8px;
    .notice-tag { font-size: 10px; padding: 3px 10px; i { font-size: 9px; } }
    .notice-text {
      font-size: 12px;
      max-width: 55vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .notice-close { right: 10px; font-size: 16px; }
}
</style>
